<template>
    <div class="modal-content">
        <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            <h4 class="modal-title text-center">Telefones de {{ name }}</h4>
        </div>
        <div class="modal-body">
            <vue-simple-spinner v-if="!loaded_phones" class="m-b-20"></vue-simple-spinner>
            <div v-if="loaded_phones && has_phones">
                <div v-if="phone" class="card-box">
                    <div class="text-right">
                        <p class="text-success m-t-5 text-uppercase font-600 font-secondary">Telefone</p>
                        <h3 class="m-b-10"><i class="fas fa-phone pull-left"></i> <span>{{ phone }}</span></h3>
                    </div>
                </div>

                <div v-if="cellphone" class="card-box">
                    <div class="text-right">
                        <p class="text-success m-t-5 text-uppercase font-600 font-secondary">Celular</p>
                        <h3 class="m-b-10"><i class="fas fa-mobile-alt pull-left"></i> <span>{{ cellphone }}</span></h3>
                    </div>
                </div>

                <p class="text-mutted m-t-20 m-b-20" v-if="!active_premium">
                    Debitamos <span class="coins-amount">{{ view_phone_amount }}<img src="/images/icone_moeda.svg" alt="Coin Icon"></span>
                    de sua conta. <a class="btn-link" target="_blank" href="https://ajuda.webquarto.com.br/article/128-o-que-sao-as-moedas-webquarto">Clique aqui</a>
                    para saber mais sobre as moedas do WebQuarto.
                </p>

                <div class="card-box">
                    <a class="text-custom"
                        role="button"
                        data-toggle="collapse"
                        href="#collapseSecurity"
                        aria-expanded="false"
                        aria-controls="collapseSecurity"><b><i class="fas fa-exclamation-triangle"></i> Veja nossas dicas para alugar com segurança e como negociar com seus futuros inquilinos!</b></a>
                    <div class="collapse" id="collapseSecurity">
                        <ul class="m-t-20">
                            <li>Use algum contrato para formalizar o aluguel e evitar problemas futuros, definindo todas as regras e condições do aluguel.</li>
                            <li class="m-t-10">Use a <b><a class="btn-link" target="_blank" href="https://ajuda.webquarto.com.br/article/91-o-que-e-a-reserva-segura-no-webquarto">Reserva Segura</a></b>, para receber o primeiro mês de aluguel, além de uma verificação de segurança de seu inquilino.</li>
                            <li class="m-t-10"><a class="btn-link" target="_blank" href="https://ajuda.webquarto.com.br/article/60-como-saber-se-alguem-esta-tentando-me-aplicar-um-golpe"><b>Siga nossas dicas</b></a>, para saber reconhecer quando alguém está tentando te aplicar um golpe.</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div v-else-if="hidden_phones && loaded_phones">
                <div class="alert alert-info">
                    <p class="text-dark">
                        {{ name }} optou por não exibir seus números de telefone. Entre em contato com {{ name }} enviando uma mensagem.
                    </p>
                </div>
            </div>
	    </div>
    </div>
</template>

<script>
	import SimpleSpinner from '../../spinner/Spinner.vue';
	export default {
		props: ['name', 'type', 'fk_user', 'active_premium', 'view_phone_amount'],
		data: function () {
			return {
				has_phones: false,
				loaded_phones: false,
				phone: '',
				cellphone: '',
				hidden_phones: false
			};
		},
        components: {
            'vue-simple-spinner': SimpleSpinner,
        },
		methods: {
			showPhoneNumbers: function () {
                if (this.loaded_phones)
                    return;

				var instance = this;
				axios.get('/user/get-phonenumbers/' + this.fk_user + '/roommate_ad').then(function (response) {
					var data = response.data;
                    instance.loaded_phones = true;

					if (data.success) {
						instance.phone = data.phone;
						instance.cellphone = data.cellphone;
						instance.has_phones = data.has_phones;

                        window.phone = {
                            phone: data.phone,
                            cellphone: data.cellphone,
                            loaded_phones: true,
                            has_phones: data.has_phones
                        };

						window.dataLayer.push({
							'event': 'show_phone_number',
							'event_category': instance.type,
							'event_label': 'show_phone_number'
						});
					} else {
                        const error = data.error ?? data.msg;

						switch (error) {
                            case 'hidden_phone':
                                instance.hidden_phones = true;
                                instance.loaded_phones = true;
                                break;
                            case 'insuficient_credits':
                                EventBus.$emit('open-modal', 'need-credits-modal');
                                break;
                            case 'need_mobile_verification':
                                EventBus.$emit('open-modal', 'verify-mobile-modal');
                                break;
                            default:
                                window.App.error('Não foi possível visualizar o telefone dessa pessoa. Entre em contato com nossa equipe de suporte!');
                        }
					}
				}).catch(function (error) {
					if (error.response && error.response.status == 401) {
						EventBus.$emit('open-modal', 'register-modal', {name: instance.name});
						window.dataLayer.push({
							'event': 'show_login_modal',
							'event_category': instance.type,
							'event_label': 'show_phone_number'
						});
					} else
						window.App.error('Ocorreu um erro inesperado. Atualize esta página e tente novamente!');
				});
			}
        },
        mounted () {
            if (window.phone) {
                this.cellphone = window.phone.cellphone;
                this.phone = window.phone.phone;
                this.has_phones = window.phone.has_phones;
                this.loaded_phones = window.phone.has_phones;
            }

        },
		created() {
            this.showPhoneNumbers();
		}
	}
</script>

<style lang="scss" scoped>
    .coins-amount {
        font-weight: bolder;
        color: #5f6261;

        img {
            margin-left: 4px;
            width: 14px;
            height: 14px;
        }
    }
</style>
